import {register} from '@shopify/theme-sections';
import YouTubePlayer from 'youtube-player';
import Player from '@vimeo/player';

export default register('featured-video', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';
    this.userSettings = JSON.parse(this.settings);
    this.videoWrapper = this.container.querySelector(`#featured-video__video--${this.id}`);

    if (this.videoWrapper) {
      if (this.userSettings.videoType == 'youtube') {
        this.player = new YouTubePlayer(this.videoWrapper, {
          videoId: this.userSettings.videoId,
          playerVars: {
            autoplay: this.userSettings.videoControls == true ? 0 : 1,
            controls: this.userSettings.videoControls == true ? 1 : 0,
            disablekb: 1,
            loop: this.userSettings.videoControls == true ? 0 : 1,
            mute: this.userSettings.videoControls == true ? 0 : 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            showinfo: 0,
          },
        });
        this.player.on('ready', () => {
          if (this.userSettings.videoControls == false) {
            this.player.mute();
            this.player.playVideo();
          }
        });
        this.player.on('stateChange', () => {
          if (this.userSettings.videoControls == false) {
            this.player.mute();
            this.player.playVideo();
          }
        });
      } else if (this.userSettings.videoType == 'vimeo') {
        this.player = new Player(this.videoWrapper, {
          id: this.userSettings.videoId,
          loop: true,
          autoplay: this.userSettings.videoControls == true ? false : true,
          controls: this.userSettings.videoControls == true ? true : false,
          muted: this.userSettings.videoControls == true ? false : true,
          playsinline: true,
          title: false,
          background: this.userSettings.videoControls == true ? false : true, // only works on paid plans
        });
      }
    }
  },
});
